/**
 * Takes a single-character string and returns true if the character is "printable"
 * (e.g. a character that would appear in a text input), and returns false if not
 * Useful when needing to filter KeyboardEvent.key values
 */
var isPrintableCharacter = function isPrintableCharacter(str) {
  return str.length === 1 && !!str.match(/\S| /);
};

export { isPrintableCharacter };
